import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/main.scss'

import * as echarts from 'echarts'
import '@wangeditor/editor/dist/css/style.css'

import VueI18n from "vue-i18n";
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import en from '../src/locales/en.json'
import zh from '../src/locales/zh.json'
Vue.use(ElementUI,{zhLocale});
Vue.use(VueI18n);


const i18n = new VueI18n({
  locale: localStorage.lang || 'cn',
  messages:{
    'en':{...en,...enLocale},
    'zh':{...zh,...zhLocale}
  }
})
Vue.use(ElementUI,{
  i18n:(key,value) =>i18n.t(key,value) //重点！！在注册Element时设置i18n的处理方法（这里有个小坑）
});

Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false




new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
